/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundErrorComponent} from '../main/error-page/not-found-error/not-found-error';
import {LayoutComponent} from './layout.component';

const routes: Routes = [{
  path: '',
  component: LayoutComponent,
  children: [
    {
      path: '',
      loadChildren: () => import('src/app/main/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
      path: 'permission-unauthorized',
      loadChildren: () => import('src/app/main/permission-unauthorized/permission-unauthorized.module').then(m => m.PermissionUnauthorizedModule)
    },
    {
      path: 'audit-dashboard',
      loadChildren: () => import('src/app/main/audit-mgmt/audit-mgmt.module').then(m => m.AuditMgmtListModule)
    },
    {
      path: 'tenants',
      loadChildren: () => import('src/app/main/tenant-mgmt-list/tenant-mgmt-list.module').then(m => m.TenantMgmtListModule)
    }, {
      path: 'external-tenant',
      loadChildren: () =>
       import('src/app/main/external-tenant-mgmt-list/external-tenant-mgmt-list.module').then(m => m.ExternalTenantMgmtListModule)
    }, {
      path: 'tenant-onboarding',
      loadChildren: () =>
       import('src/app/main/tenant-onboarding/tenant-onboarding.module').then(m => m.TenantOnboardingModule)
    }, 
    // {
    //   path: 'my-account',
    //   loadChildren: () => import('src/app/main/my-account/my-account.module').then(m => m.MyAccountModule)
    // }, 
    {
      path: 'tenants',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/tenants-mgmt/tenants-mgmt.module').then(m => m.TenantsMgmtModule)
      }
      ]
    },
    {
      path: 'tenantrequest',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/tenants-mgmt/create-tenant/create-tenant.module').then(m => m.CreateTenantModule)
      }
      ]
    },
    {
      path: 'instance',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/instances-mgmt/instances-mgmt.module').then(m => m.InstancesMgmtModule)
      }
      ]
    },
    {
      path: 'tenant-details',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/tenant-mgmt-list/tenant-mgmt-list.module').then(m => m.TenantMgmtListModule)
      }
      ]
    },
    // {
    //   path: 'updates-solution',
    //   children: [{
    //     path: '',
    //     loadChildren: () =>
    //     import('src/app/main/continuous-updates-solution/continuous-updates-solution.module').then(m => m.ContinuousUpdatesSolutionModule)
    //   }]
    // },
    {
      path: 'solutions',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/solution-onboarding/solution-onboarding.module').then(m => m.SolutionOnboardingModule)
      }]
    },
    {
      path: 'lob',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/line-of-business/line-of-business.module').then(m => m.LineOfBusinessModule)
      }]
    },
    {
      path: 'components',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/components-mgmt/components-mgmt.module').then(m => m.ComponentsMgmtModule)
      }]
    },
    {
      path: 'subscription',
      children: [{
        path: '',
        // eslint-disable-next-line max-len
        loadChildren: () => import('src/app/main/subscription-mgmt-list/subscription-mgmt-list.module').then(m => m.SubscriptionMgmtListModule)
      }]
    },
    {
      path: 'edge-network',
      children: [{
        path: '',
        // eslint-disable-next-line max-len
        loadChildren: () => import('src/app/main/edge-network/edge-network.module').then(m => m.EdgeNetworkModule)
      }]
    },
    {
      path: 'shared-services',
      children: [{
        path: '',
        // eslint-disable-next-line max-len
        loadChildren: () => import('src/app/main/shared-services/shared-services.module').then(m => m.SharedServicesModule)
      }]
    },
    {
      path: 'cost',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/cost-mgmt/cost-mgmt.module').then(m => m.CostsMgmtModule)
      }
      ]
    },
    {
      path: 'services',
      children: [{
        path: '',
        loadChildren: () => import('src/app/main/change-mgmt/change-mgmt.module').then(m => m.ChangeMgmtModule)
      }
      ]
    },
    {
      path: 'error',
      loadChildren: () => import('src/app/main/error-page/error-page.module').then(m => m.ErrorPageModule)
    }, {
      path: 'comingsoon',
      loadChildren: () => import('src/app/main/coming-soon/coming-soon.module').then(m => m.ComingSoonModule)
    },{
      path: 'isb',
      loadChildren: () => import('src/app/main/view-request/view-request.module').then(m => m.ViewRequestModule)
    },
    {
      path: 'isb/isbPackages',
      loadChildren: () => import('src/app/main/view-request/view-request.module').then(m => m.ViewRequestModule)
    },
    {
      path: 'external-instance',
      loadChildren: () => import('src/app/main/external-instance/external-instance.module').then(m => m.ExternalInstanceModule)
    },
    {
      path: 'roles',
      loadChildren: () => import('src/app/main/roles/roles.module').then(m => m.RolesModule)
    },
    {
      path: 'groups',
      loadChildren: () => import('src/app/main/groups/groups.module').then(m => m.GroupsModule)
    },
    {
      path: '**',
      component: NotFoundErrorComponent
    }
  ]

}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
